export const environment = {
  PRODUCTION: false,
  ENVIRONMENT_NAME: 'qa',
  PORT: 8001,
  PUBLIC_KEY: 'lshZsrDTAjQ=',
  SALT_KEY: 'lshZsrDTAjQ=',
  API_URL: 'https://forevermemoriesapidev.alliancetek.net/api/v1',
  PROJECT_NAME: 'forever-web',
  S3_BUCKET_NAME: 'nch4evrpentmorbeif83lp',
  S3_REGION: 'us-east-2',
  S3_ACCESS_KEY_ID: 'AKIAXKIS2FFSG75YVXF6',
  S3_SECRET_ACCESS_KEY: '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',
  S3_BUCKET_FOLDER_PROFILE_IMAGE: 'profile-images',
  S3_BUCKET_FOLDER_FAMILY_LOGO: 'family-logos',
  S3_BUCKET_FOLDER_MEMBER_PHOTO: 'member-photos',
  S3_BUCKET_FOLDER_STORY_MEDIA: 'storymedia',
  S3_BUCKET_FOLDER_STORY_VIDEO: 'storyvideo',
  S3_BUCKET_FOLDER_STORY_AUDIO: 'storyaudio',
  S3_BUCKET_FOLDER_STORY_AUDIO_IMAGE: 'storyaudioimage',
  GOOGLE_CLIENT_ID: '302740449763-r33jo92krj7gboe4grhabr1n48sr9929.apps.googleusercontent.com',
  FACEBOOK_APP_ID: '',
  APPLE_CLIENT_ID: '',
  APPLE_REDIRECT_URI: '',
};
